module.exports = __webpack_public_path__ + "img/meituan.dc3e4d0b.png";